import { PropsWithChildren } from 'react';
import './body-section.component.scss';

interface BodySectionComponentProps extends PropsWithChildren {
  className?: string;
}
export const BodySectionComponent = ({
  children,
  className,
}: BodySectionComponentProps) => {
  return <div className={`body-section ${className ?? ''}`}>{children}</div>;
};
